import * as React from 'react';
import './ProductSizing.styles.less';
import { IProductSizingProps } from "./ProductSizing.types";

export const ProductSizing = (props: IProductSizingProps) => {
    // Extract sizes and part numbers from the chart data
    const getSizingData = (): {sizes: string[], partNumbers: string[]} | null => {
        // If we don't have chart data, return null
        if (!props.chart || !props.chart.rows || !props.chart.rows.length) {
            return null;
        }

        try {
            // Using type assertion to work with the actual structure without TypeScript errors
            const chart = props.chart as any;
            const rows = chart.rows || [];
            const sizeValues: string[] = [];
            const partNumberValues: string[] = [];
              
            // Check if the chart has a header field with columns
            if (!chart.header[0]?.columns) {
                console.log('ProductSizing - Header or columns missing');
                return null;
            }
            
            const headerColumns = chart.header[0].columns;

            // Find the index of the column that contains 'size' in its name
            const sizeColumnIndex = headerColumns.findIndex((column: any) => 
                column && typeof column === 'object' && column.name.toLowerCase().includes('size'));
                
            // If we didn't find a size column, return null
            if (sizeColumnIndex === -1) {
                console.log('ProductSizing - No size column found in headers');
                return null;
            }

            // Based on the actual data structure, extract sizes and part numbers
            for (const row of rows) {
                // Extract size using the found size column index
                // Account for different possible row structures
                let sizeValue = null;
                
                if (row.columns) {
                    // If row has columns array with value objects
                    if (row.columns.length > sizeColumnIndex && row.columns[sizeColumnIndex]?.value) {
                        sizeValue = String(row.columns[sizeColumnIndex].value);
                    }
                    // If row has columns array with direct values
                    else if (row.columns.length > sizeColumnIndex && row.columns[sizeColumnIndex]) {
                        sizeValue = String(row.columns[sizeColumnIndex]);
                    }
                } else if (Array.isArray(row)) {
                    // If row is a direct array
                    if (row.length > sizeColumnIndex && row[sizeColumnIndex]) {
                        sizeValue = String(row[sizeColumnIndex]);
                    }
                }
                
                if (sizeValue) {
                    sizeValues.push(sizeValue);
                    
                    // If we have part numbers in the row data, add them
                    if (row.partNumber) {
                        partNumberValues.push(row.partNumber);
                    }
                }
            }
            
            // Only return data if we have sizes or part numbers
            if (sizeValues.length === 0 && partNumberValues.length === 0) {
                console.log('ProductSizing - No size or part number values found, returning null');
                return null;
            }
            
            return {
                partNumbers: partNumberValues,
                sizes: sizeValues,
            };
        } catch (error) {
            console.error('Error extracting sizing data:', error);
            return null;
        }
    };

    // Get the sizing data
    const sizingData = getSizingData();
    
    // If no data, don't render anything
    if (!sizingData) {
        console.log('ProductSizing - No sizing data returned, component will not render');
        return null;
    } else {
        console.log('ProductSizing - Component will render with data:', sizingData);
    }
    
    const { sizes, partNumbers } = sizingData;
    // const { sizes } = sizingData;

    return (
        <div className="Chart">
            {partNumbers.length > 0 && (
                <>
                    <div className="part-chart-header">Part numbers</div>
                    <table className="part-chart-table">
                        <tbody>
                            <>
                            <tr className='chartHeaders'>
                                {sizes.length > 0 && (
                                <th key={`header-col-size`}>Size</th>
                                )}
                                <th key="header-col-partNumber">Part Number</th>
                            </tr>
                            
                            {partNumbers.map((part: string, index: number) => (
                                <tr key={`part-${index}`}>
                                    {sizes.length > 0 &&
                                        <td>{sizes[index]}</td>
                                    }
                                    <td>{part}</td>
                                </tr>
                            ))}
                            </>
                        </tbody>
                    </table>
                </>
            )}
        </div>
    );
}
